import { memo, useEffect, useState } from "react";
import type { FC } from "react";
import { Link, useLocation } from 'react-router-dom';
import { useTranslation,Trans } from 'react-i18next';

import resets from "../_resets.module.css";
import classes from "./Top.module.scss";

/*Title*/
import { SectionTitle } from "../common/SectionTitle/SectionTitle";
import { SectionTitle_sub } from "../common/SectionTitle_sub/SectionTitle_sub";

/*section*/
import { Contact } from "../common/Contact/Contact";
import TopNews from '../common/PostList/TopNews';


/*Button*/
import { Button_circle } from "../common/Button/Button_circle/Button_circle";
import { Button_ellipse } from "../common/Button/Button_ellipse/Button_ellipse";

/*Image*/
import interviewItemImg01 from "../../assets/images/iMG_73121.jpg";
import interviewItemImg02 from "../../assets/images/dSC_35641.jpeg";
import interviewItemImg03 from "../../assets/images/_447011.jpeg";
import imgstudentCount4000 from '../../assets/images/text_4000.png';
import imgStudyImg01 from '../../assets/images/dSC008951.jpeg'

/*SVG code*/
import { BubbleBase } from "../common/BubbleBase";
import { IconMail } from "../common/IconMail";
import { RecommendationBubble } from "./RecommendationBubble";
import { NumberIcon_base } from "./NumberIcon_base";



interface Props {
  className?: string;
}
/* @figmaId 5:3 */
export const Top: FC<Props> = memo(function Top(props = {}) {
  const { t, i18n } = useTranslation();
  const location = useLocation(); // 現在のロケーションを取得
  const [isLanguageReady, setIsLanguageReady] = useState(false);
  
  // パスから期待される言語を取得
  const pathSegments = location.pathname.split('/').filter(segment => segment !== '');
  const expectedLanguage = pathSegments[0] || 'ja';
  
  useEffect(() => {
    // i18nの言語変更を監視
    const handleLanguageChange = (lng: string) => {
      if (lng === expectedLanguage) {
        setIsLanguageReady(true);
      }
    };
    
    // 初期状態をチェック
    if (i18n.language === expectedLanguage) {
      setIsLanguageReady(true);
    }
    
    // イベントリスナーを追加
    i18n.on('languageChanged', handleLanguageChange);
    
    return () => {
      i18n.off('languageChanged', handleLanguageChange);
    };
  }, [expectedLanguage]);
  
  // 言語が準備できていない場合は待機
  if (!isLanguageReady) {
    return null;
  }
  
  // 現在の言語コードを取得
  const langCode = i18n.language;

  return (

    <div className={`${resets.clapyResets} ${classes.root} contents`}>


      {/*heroSection------------*/}
      <div className={classes.heroSection}>
        <div className={classes.headlineWrapper}>
          <div className={classes.headlineText}><Trans i18nKey="top:hero.headlineText01" /></div>
          <div className={classes.headlineText}><Trans i18nKey="top:hero.headlineText02" /></div>
          <div className={classes.headlineText}><Trans i18nKey="top:hero.headlineText03" /></div>
        </div>
        {/*
        <Button_circle className={classes.playButton} classes={{text: "whiteText", arrow: "blueArrow"}} text={t('top:hero.playButton')} link="DUMMY"/> */}
      </div>

      {/*news------------*/}
      <section className={`${classes.news} contentWidth`}>
        <SectionTitle
          className={classes.newsTitle}
          classes={{color:"grad"}}
          text="NEWS"
        />

        <TopNews />


        <Button_circle className={classes.newsButton} text={t('common:button.viewAll')} link="/news"/>
      </section>


      


 {/*about------------*/}
      <section className={`${classes.about} LargeMarginUnder`}>
      <SectionTitle
          className={classes.aboutTitle} classes={{color:"grad"}}
          text="HADO EDUCATION"
        />
        <SectionTitle_sub
          className={classes.aboutSubTitle}
          text= {t('top:about.aboutSubTitle')}
        />
        <div className={classes.description}>
          <div className={`${classes.descriptionWrapper} contentWidth`}>
            <div className={classes.descriptionText}>
            {t('top:about.descriptionText01')}
            </div>
            <div className={classes.descriptionText}>
            <Trans i18nKey="top:about.descriptionText02" />
            </div>
            <div className={classes.descriptionText}>
            <Trans i18nKey="top:about.descriptionText03" />
            </div>
            <div className={classes.descriptionText}>
            {t('top:about.descriptionText04')}
            </div>
          </div>
        </div>

        <div className={classes.recommendationBubble}>
          <RecommendationBubble className={classes.bubbleIcon} />
          <div className={classes.recommendationTextWrapper}>
            <div className={classes.recommendationText}> <Trans i18nKey="top:about.recommendationText" /></div>
          </div>
        </div>

        <div className={classes.pointsContainer}>
          <div className={classes.numberIcons}>
            <NumberIcon_base className={classes.numberIcon} />
            <div className={classes.pointNumber1}>01</div>
            <div className={classes.pointNumber2}>02</div>
            <div className={classes.pointNumber3}>03</div>
          </div>
          <div className={classes.pointsTextContainer}>
            <div className={classes.pointText}>{t('top:about.pointText01')}</div>
            <div className={classes.pointText}>{t('top:about.pointText02')}</div>
            <div className={classes.pointText}>{t('top:about.pointText03')}</div>
          </div>
        </div>

        <Button_ellipse
          className={classes.aboutDetailsButton}
          link="/about"
        />
      </section>

 {/*student club------------*/}
      <section className={classes.studentClub}>
        <SectionTitle_sub
          className={classes.studentClubSubTitle}
          text={t('top:studentClub.studentClubSubTitle')}
        />
        <SectionTitle
          className={classes.studentClubTitle}
          classes={{color:"grad"}}
          text={t('top:studentClub.studentClubTitle')}
        />

        <div className={classes.description}>
          <div className={`${classes.descriptionWrapper} contentWidth`}>
            <div className={classes.descriptionText}>
            <Trans i18nKey="top:studentClub.descriptionText">
            <br className="adbreak" />
            </Trans>
            </div>
          </div>
        </div>

        <Button_ellipse
          className={classes.studentClubDetailsButton}
          link="/student-club"
        />
      </section>


{/*caseStudy------------*/}
      <section className={classes.caseStudy}>
        <SectionTitle
          className={classes.caseStudyTitle}
          classes={{color:"grad"}}
          text={t('top:caseStudy.caseStudyTitle')}
        />
        <div className={classes.schoolTable}>
          <div className={classes.schooltableTitle}>{t('top:caseStudy.schooltableTitle')}</div>
          <div className={classes.schooltableContent}>
            <div className={classes.schooltableText}>{t('top:caseStudy.schooltableText01')}</div>
            <div className={classes.schooltableText}>{t('top:caseStudy.schooltableText02')}</div>
            <Button_circle className={classes.schoolListButton} text={t('top:caseStudy.schoolListButton')} link="/school-list"/>
            <ul className={classes.schoolList}>
              <li className={classes.schoolListItem}>愛媛県立東伊予高等学校</li>
              <li className={classes.schoolListItem}>葛飾区立飯塚小学校</li>
              <li className={classes.schoolListItem}>金沢学院大学</li>
              <li className={classes.schoolListItem}>広島県立広島井口高等学校</li>
              <li className={classes.schoolListItem}>江戸川区立下鎌田西小学校</li>
              <li className={classes.schoolListItem}>芝浦工業大学 附属中学高等学校</li>
              <li className={classes.schoolListItem}>芝浦工大</li>
              <li className={classes.schoolListItem}>渋谷区立鉢山中学校</li>
              <li className={classes.schoolListItem}>神戸龍谷高等学校</li>
              <li className={classes.schoolListItem}>神奈川大学</li>
              <li className={classes.schoolListItem}>秦野市立本町中学校</li>
              <li className={classes.schoolListItem}>杉並区立天沼中学校</li>
              <li className={classes.schoolListItem}>西東京市立田無小学校</li>
              <li className={classes.schoolListItem}>青梅市立第二小学校</li>
              <li className={classes.schoolListItem}>石川県立小松明峰高等学校</li>
              <li className={classes.schoolListItem}>川崎市立平中学校</li>
              <li className={classes.schoolListItem}>大田区立南六郷小学校</li>
              <li className={classes.schoolListItem}>大島町立第一中学校</li>
              <li className={classes.schoolListItem}>中野区立南台小学校</li>
              <li className={classes.schoolListItem}>町田市小山田南小学校</li>
              <li className={classes.schoolListItem}>町田市立小川小学校</li>
              <li className={classes.schoolListItem}>町田市立大戸小学校</li>
              <li className={classes.schoolListItem}>町田市立武蔵丘中学校</li>
              <li className={classes.schoolListItem}>追手門中学高校</li>
              <li className={classes.schoolListItem}>都立中野工業高等学校</li>
              <li className={classes.schoolListItem}>都立北豊島工業高等学校</li>
              <li className={classes.schoolListItem}>都立墨田工業高等学校</li>
              <li className={classes.schoolListItem}>土浦市立新治学園義務教育学校</li>
              <li className={classes.schoolListItem}>東久留米第一小学校</li>
              <li className={classes.schoolListItem}>東京学芸大学附属世田谷小学校</li>
              <li className={classes.schoolListItem}>東京都立神代高等学校定時制</li>
              <li className={classes.schoolListItem}>東京都立蔵前工業高等学校</li>
              <li className={classes.schoolListItem}>八丈高等学校定時制</li>
              <li className={classes.schoolListItem}>品川区立荏原第一中学校</li>
              <li className={classes.schoolListItem}>武蔵村山市立第一小学校</li>
              <li className={classes.schoolListItem}>福井市大東中学校</li>
              <li className={classes.schoolListItem}>福岡第一高校</li>
              <li className={classes.schoolListItem}>文京区立指ヶ谷小学校</li>
              <li className={classes.schoolListItem}>豊島高等学校</li>
              <li className={classes.schoolListItem}>墨田区立横川小学校</li>
              <li className={classes.schoolListItem}>練馬区立石神井南中学校</li>
            </ul>
          </div>
        </div>
      </section>


{/*interview------------*/}
      <section id="interview" className={classes.interview}>
        <SectionTitle
          className={classes.interviewTitle}
          classes={{color:"grad"}}
          text={t('top:interview.interviewTitle')}
        />

        <ul className={`${classes.interviewList} contentWidth`}>
          <li className={classes.interviewItem}>
            <Link to={`/${langCode}/post/5757`}>
              <img src={interviewItemImg01}  className={classes.interviewItemImg}/>
              <div className={classes.interviewItemTitle}>{t('top:interview.interviewItemTitle01')}</div>
              <div className={classes.interviewItemText}>
              {t('top:interview.interviewItemText01')}
              </div>
              <div className={classes.circleBubble}>
                <BubbleBase className={classes.circleBubbleBase} />
                <div className={classes.circleBubbleBaseText}><Trans i18nKey="top:interview.circleBubbleBaseText01" /></div>
              </div>
            </Link>
          </li>
          <li className={classes.interviewItem}>
            <Link to={`/${langCode}/post//6689`}>
            <img src={interviewItemImg02}  className={classes.interviewItemImg}/>
              <div className={classes.interviewItemTitle}>{t('top:interview.interviewItemTitle02')}</div>
              <div className={classes.interviewItemText}>
              {t('top:interview.interviewItemText02')}
              </div>
              <div className={classes.circleBubble}>
                <BubbleBase className={classes.circleBubbleBase} />
                <div className={classes.circleBubbleBaseText}><Trans i18nKey="top:interview.circleBubbleBaseText02" /></div>
              </div>
            </Link>
          </li>
          <li className={classes.interviewItem}>
            <Link to={`/${langCode}/post/4988`}>
            <img src={interviewItemImg03}  className={classes.interviewItemImg}/>
              <div className={classes.interviewItemTitle}>{t('top:interview.interviewItemTitle03')}</div>
              <div className={classes.interviewItemText}>
              {t('top:interview.interviewItemText03')}
              </div>
              <div className={classes.circleBubble}>
                <BubbleBase className={classes.circleBubbleBase} />
                <div className={classes.circleBubbleBaseText}><Trans i18nKey="top:interview.circleBubbleBaseText03" /></div>
              </div>
            </Link>
          </li>
        </ul>

      </section>


{/*educationStudy------------*/}
      <section className={classes.educationStudy}>
        <div className={classes.educationStudyTitle}><Trans i18nKey="top:educationStudy.educationStudyTitle" /></div>
        <div className={`${classes.studyTable} contentWidth`}>

          <div className={classes.studyTextWrap}>
            <div className={classes.yearLabel}>{t('top:educationStudy.yearLabel')}</div>
            <div className={classes.studentCount}>
              <img src={imgstudentCount4000} className={classes.imgstudentCount4000}/>
            </div>
            <div className={classes.countSuffix}>{t('top:educationStudy.countSuffix')}</div>
          </div>
          <div className={classes.studyImage}><img src={imgStudyImg01}  className={classes.imgStudyImg01}/></div>
        </div>

        <div className={classes.innovationContestWrap}>
          <div className={classes.contestTitle}>
          {t('top:educationStudy.contestTitle')}
          </div>
          <div className={classes.contestSubTitle}>
          {t('top:educationStudy.contestSubTitle')}
          </div>
        </div>
        <Button_ellipse
          className={classes.contestDetailButton}
          link="/post/6634"
        />

{/*introductionFlow------------*/}
        <div className={`${classes.introductionFlow} contentWidth`}>
          <div className={classes .flowTitle}>{t('top:introductionFlow.flowTitle')}</div>

          <div className={classes.flowContent}>
            <ol className={classes.stepList}>
              <li className={classes.stepItem}>
                <div className={classes.stepTitle}>
                  <div className={classes.stepNumber}>01</div>
                  <div className={classes.stepDescription}>{t('top:introductionFlow.stepDescription01')}</div>
                </div>
                <div className={`${classes.iconItem} ${classes.iconItem01}`}>
                <div className={classes.iconWrapper}><IconMail className={classes.icon} /></div>
              </div>
              </li>
              <li className={classes.stepItem}>
              <div className={classes.stepTitle}>
                <div className={classes.stepNumber}>02</div>
                <div className={classes.stepDescription}><Trans i18nKey="top:introductionFlow.stepDescription02" /></div>
                </div>
                <div className={classes.iconItem}>
                <div className={classes.iconBox02}></div>
              </div>
              </li>
              <li className={classes.stepItem}>
              <div className={classes.stepTitle}>
                <div className={classes.stepNumber}>03</div>
                <div className={classes.stepDescription}><Trans i18nKey="top:introductionFlow.stepDescription03" /></div>
                </div>
                <li className={classes.iconItem}>
                <div className={classes.iconBox01}></div>
              </li>
              </li>
            </ol>

            <p className={classes.supportText}>
            <Trans i18nKey="top:introductionFlow.supportText" />
            </p>

          </div>


        </div>
      </section>

{/*contact------------*/}
<Contact className={classes.contact} />


    </div>
  );
});